import { repository } from '@/api/base'

export default {
  async findAll(pageNumber = 0, filters = {}) {
    const { data } = await repository.post(`/dictionary/disciplineOriginal/findAll/${pageNumber}`, filters)
    return data
  },

  async findAllDictionary() {
    const { data } = await repository.get('/dictionary/disciplineOriginal/findAll')
    return data
  },

  async findById(id) {
    const { data } = await repository.get(`/dictionary/disciplineOriginal/${id}`)
    return data
  },

  async create(body) {
    const { data } = await repository.post('/dictionary/disciplineOriginal', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put('/dictionary/disciplineOriginal', body)
    return data
  },

  async delete(id) {
    const { data } = await repository.delete(`/dictionary/disciplineOriginal/${id}`)
    return data
  },

  async findBySubjectName(name) {
    const { data } = await repository.get(`/dictionary/disciplineOriginal/findByName/${name}`)

    return data
  }
}
